import React from "react";
import { Modal } from "react-bootstrap";
import PickupForm from "../app/PickupForm";
import modalStyles from "../../styles/common/Modal.module.css";

interface PickupFormModalProps {
  show: boolean;
  onHide: () => void;
}

const PickupFormModal: React.FC<PickupFormModalProps> = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      scrollable={true}
      className={modalStyles.modalContainer}
      contentClassName={modalStyles.scaleIn}
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title as="h3" className={modalStyles.modalTitle}>Solicitar Recogida</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "24px 32px" }}>
        <PickupForm isModal={true} />
      </Modal.Body>
    </Modal>
  );
};

export default PickupFormModal;
